import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { parseParams } from "../../../helpers/clean-object";
import { CREATE_REFERENCE } from "../references.queries";

interface CreateReferenceInput {
  name: string;
  url: string;
  imgUrl: string;
  reference: string;
  lastQuantity: number;
  lastPrice: number;
  userId: number;
}

interface CreateReferenceData {
  createReference: {
    ok: boolean;
    error?: string;
    id?: number;
  };
}

interface CreateReferenceVariables {
  input: CreateReferenceInput;
}

interface IProps {
  defaultValues: Partial<CreateReferenceInput>;
  onCompleted: (id?: number) => any;
  onError: (message: string) => any;
}

export const useCreateReference = ({
  defaultValues,
  onCompleted,
  onError,
}: IProps) => {
  const form = useForm<CreateReferenceInput>({
    mode: "all",
    defaultValues: defaultValues as CreateReferenceInput,
  });

  const [mutate, { loading }] = useMutation<
    CreateReferenceData,
    CreateReferenceVariables
  >(CREATE_REFERENCE, {
    refetchQueries: ["GetReferences"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createReference?.ok) {
        onCompleted(data?.createReference?.id);
      } else {
        throw Error(data?.createReference?.error ?? "Error");
      }
    } catch (error: any) {
      console.log(error);
      onError(error.message);
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
